import ComponentManager from '@/Management/ComponentManager';
import ToastViewModelType from '@/Components/Toast/ToastViewModel';
import ToastType from '@/Components/Toast/Toast';

export default class ToastService {
    private static viewModels: ToastViewModelType[] = [];
    private static maxToasts: number = 7;

    public static showToastByMessage(message: string) : void {
        const ToastViewModel = ComponentManager.getViewModel<typeof ToastViewModelType>('ToastViewModel');
        const vm = new ToastViewModel({ message: message});
        ToastService.showToast(vm);
    }
    
    public static showToast(viewModel: ToastViewModelType): void {
        ToastService.hideToastsIfNecessary();

        const Toast = ComponentManager.getControl<typeof ToastType>('Toast');
        const control = new Toast(viewModel);

        const isAppended = control.appendTo('[data-region="Toasts"]');
        if (isAppended) {
            ToastService.viewModels.push(viewModel);
            viewModel.addOnClosedCallback((vm) => ToastService.onViewModelClosed(vm));
        }
    }

    private static onViewModelClosed(vm: ToastViewModelType): void {
        const index = ToastService.viewModels.indexOf(vm);
        if (index !== -1)
            ToastService.viewModels.splice(index, 1);
    }

    private static hideToastsIfNecessary(): void {
        let length = ToastService.viewModels.length;
        while (length > ToastService.maxToasts) {
            const vm = ToastService.viewModels[0];
            vm.close();

            // To avoid endless loop if something wrong happened
            const newLength = ToastService.viewModels.length;
            if (length === newLength)
                break;

            length = newLength;
        }
    }
}